module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "title3"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("One")])]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle"
  }, [_vm._v("SETTLING IN")]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0005.jpg",
      "src": "images/e9781439629895_i0005.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This gentleman, with the wide tie and the walrus moustache, is the man who founded Winter Park. Loring A. Chase was a Union Army veteran with a career that included work as a real-estate broker. He saw that Florida was ripe for development, and he built a resort so that others suffering from the same ailments that drove him south might find a “winter park.” He lived to see the little town prosper and died in 1906 at the age of 67. (Courtesy of Rollins College.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0006.jpg",
      "src": "images/e9781439629895_i0006.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("After the train depot went up, the second building that rose in Winter Park was Rogers House Inn, which opened April 8, 1881. The city’s investors found Mr. and Mrs. A. E. Rogers camping near town and offered them a lakeside lot, provided they build an inn there. Luckily, Mrs. Rogers was a great cook and the inn was a hit. Still, for this picture postcard, Mr. Rogers forgot to put away his ladder.")])])])])]), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('a', {
    attrs: {
      "id": "title3"
    }
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0007.jpg",
      "src": "images/e9781439629895_i0007.jpg"
    }
  })])]), _c('div', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "title3"
    }
  }), _c('p', {
    staticClass: "p"
  }, [_c('a', {
    attrs: {
      "id": "title3"
    }
  }, [_c('span', [_vm._v("Chase and Chapman’s third structure was this building that served as the post office, town hall, and Ergood’s Dry Goods store. It was also a local hangout, as the newspaper reported in 1892: “Postmaster Thayer requests the crowd that usually assembles at the post-office every Sunday evening to please keep quiet during the distribution of the mails. The building is small and the noise and glib which this crowd generally keeps up is simply disgusting and should be stopped.”"), _c('sup')])]), _c('span', {
    attrs: {
      "href": "#/e9781439629895_bm01#end_en3",
      "id": "ref_end_en3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("1")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0008.jpg",
      "src": "images/e9781439629895_i0008.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("By the time this postcard was mailed in 1900, Ergood’s Dry Goods had some company on Park Avenue, though the city remained a small town. As late as 1905, the Travelers Insurance Company asked Winter Park to protect it from damage claims due to hogs running at large on city streets. The city looked into it but said until the human population grew, hogs could continue to roam.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0009.jpg",
      "src": "images/e9781439629895_i0009.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Looking south on Park Avenue just a few years later, the view hasn’t changed much. The street is identified as “East Park Ave.,” which it was called for many years. There was supposed to be a West Park directly opposite, on the park’s other side, that mirrored East Park, but it was never completed. One block of it remains between New England Avenue and Welborne.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0010.jpg",
      "src": "images/e9781439629895_i0010.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Lake Osceola lies just two blocks east of Park Avenue, and though in the 21st century it is ringed with homes, this vintage card shows the lake at a time when—other than a few old pine trees—distant orange groves are the only things in sight. The founders initially planted 1,000 orange trees along the Boulevard (now Morse Boulevard), which they bought from a local grower for 50 cents each."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781439629895_bm01#end_en4",
      "id": "ref_end_en4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("2")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0011.jpg",
      "src": "images/e9781439629895_i0011.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Developers Chase and Chapman met every train that stopped in Winter Park and toured visitors around the town site in a horse and buggy. It could be slow going on Winter Park’s primitive roads. This vintage card was produced around the turn of the 20th century, when the non-picture side of the card was used for the address only, so messages such as “Trust you are well” were written across the front.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "59%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0012.jpg",
      "src": "images/e9781439629895_i0012.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Since Winter Park had very little development to sell in its early years, its founders sold potential buyers on its atmosphere. They wrote in their prospectus, “The wonderful healthfulness of the climate of Winter Park is due to its high altitude, freedom from swamps, perfect drainage, ocean breezes which sweep away fogs and malarial germs, and lastly, the absolutely pure water found in its lakes, springs and wells. Hundreds of people can be found in Winter Park who will testify that they have been either cured or greatly relieved of asthma, bronchitis, catarrh, and even consumption, by living here. The effect of the climate upon lung and throat troubles is wonderful.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781439629895_bm01#end_en5",
      "id": "ref_end_en5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("3")])])]), _vm._v(" Winter Park’s “high altitude” is all of 92 feet above sea level; but as you can see from the vintage card on this page, altitude was still a bigger selling point than the state of Winter Park’s main thoroughfares. It wasn’t until 1898, by the way, that it was established that malaria was caused by mosquitoes, not “malarial germs.”")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0013.jpg",
      "src": "images/e9781439629895_i0013.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Just five years after the founding of Winter Park, a most astonishing building arose above the town. The Seminole Hotel opened for business on New Year’s night, 1886. With five floors and an elevator, it was the largest hotel south of Jacksonville. In its first three months of operation, 2,300 visitors stayed at the hotel, and many others were turned away. This “postal card” is dated 1898. (Courtesy of Russell V. Hughes.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0014.jpg",
      "src": "images/e9781439629895_i0014.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This postcard shows Seminole Hotel guests enjoying one of the hotel’s steam yachts; however, they could also use the hotel’s sailboats or rowboats. In addition, the 250-room resort had a bowling alley, tennis courts, a croquet lawn, a billiard hall, and a full orchestra. In 1894, the hotel added electric lighting, and that had to improve the billiard games. (Courtesy of Rollins College.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0015.jpg",
      "src": "images/e9781439629895_i0015.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Guests of the Seminole didn’t have to walk the sandy streets from the train station to the hotel. This horse-drawn trolley plied a regular half-mile route between the two, along what is now New England Avenue. Long distance rail service was excellent as well; by 1888, you could take a sleeper from New York to Winter Park without changing trains. (Courtesy of the Florida State Archives.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0016.jpg",
      "src": "images/e9781439629895_i0016.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The season at the Seminole Hotel was only three months long, opening in January and closing at the end of March, and during a visit guests dressed up in their best finery. The canal shown on this card is one of several among the Winter Park lakes built by the timber companies. Here, it is being used just for fun by these beautifully dressed vacationers, including the dapper man in the rowboat wearing a bowler hat.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0017.jpg",
      "src": "images/e9781439629895_i0017.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Surrounding the city were the citrus groves that served as Winter Park’s second economic engine. By 1888, there were 40,000 orange trees within one-and-a-half miles of the Winter Park train depot. The writer Harriet Beecher Stowe, who had a home in Florida, claimed a single tree could yield 10,000 oranges in one year."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781439629895_bm01#end_en6",
      "id": "ref_end_en6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("4")])])]), _vm._v(" It should be remembered that she was a fiction writer.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0018.jpg",
      "src": "images/e9781439629895_i0018.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In the 19th century, the grapefruit was almost unheard of in the North. In 1887, Winter Park’s Capen & Co. changed all that when its owner bought up all the grapefruit he could find and sold 190,000 to northern shippers at 1¢ each. He turned a tidy profit, but you could get 2¢ apiece for oranges. Notice the spelling of the fruit on this vintage card. (Courtesy of the Florida State Archives.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "58%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0019.jpg",
      "src": "images/e9781439629895_i0019.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Citrus continued to be a delicacy in the 1880s and 1890s because people across the United States didn’t get fresh fruit and vegetables all year, as people do today. In 1884, even with the proliferation of the railroads, it still took 34 days to get a load of oranges from Florida to Chicago, and by then a percentage of the fruit was ruined."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781439629895_bm01#end_en7",
      "id": "ref_end_en7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("5")])])]), _vm._v(" Consequently, citrus, with its brightly colored fruit and soft-scented blooms, continued to be an attraction for Florida visitors, as vintage postcards of the day show. On many postcards of the era, visitors marveled at the groves. One Winter Park visitor wrote home, “I love the smell of orange blossoms, which is in the air everywhere.” The Winter Park Company advertised the city as “a collection of beautiful villas in the midst of the orange groves.” The young lady in the large straw hat posing here “Gathering Grape Fruit In Florida” looks as sunny as the scene. (Courtesy of the Florida State Archives.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0020.jpg",
      "src": "images/e9781439629895_i0020.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In 1889, millionaire Henry Flagler came to visit Winter Park. His Ponce de Leon Hotel in St. Augustine had opened a year behind Winter Park’s Seminole, and it is possible he came to look over the competition. He arrived that winter in his private railroad car, bringing with him William Rockefeller, among other financial luminaries. Flagler’s investments in Florida caused the state’s first land boom. (Courtesy of the Florida State Archives.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0021.jpg",
      "src": "images/e9781439629895_i0021.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Flagler was in his 50s when he started his developments in Florida. He told reporters, “There was once a good old church member who had always lived a correct life, until well advanced in years he got on a spree. While in this state he met his good pastor. After being roundly upbraided for his condition he replied, ‘I have been giving all my days to the Lord hitherto, and now I’m taking one for myself.’ ”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781439629895_bm01#end_en8",
      "id": "ref_end_en8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("6")])])]), _vm._v(" (Courtesy of the Florida State Archives.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0022.jpg",
      "src": "images/e9781439629895_i0022.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Winter Park residents were quick to establish a lending library, and just seven years after the city was founded, it could boast a library of more than 1,000 volumes. In 1901, construction began on the city’s first library building, which opened in April 1902 at the corner of Interlachen and Fairbanks. The fence around the library must have been very helpful in keeping out those wandering hogs.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0023.jpg",
      "src": "images/e9781439629895_i0023.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The city had its first church building in 1884 when services were held at the Congregational church. Things weren’t quite ready—there was cloth on the windows in place of glass, and planks in place of pews. The Rev. Dr. Edward Hooker—later the first president of Rollins College—served as the church’s pastor. His wife was president of the library.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0024.jpg",
      "src": "images/e9781439629895_i0024.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Methodists met at the Congregational church until they dedicated their own sanctuary on Easter Sunday, April 5, 1896. After attending one Easter service, diarist Mary Brown—who was an Episcopalian but worshipped at several of the local churches, and who was always known for her frankness—wrote the following in her diary: “14 present. Nearly all late.”")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0025.jpg",
      "src": "images/e9781439629895_i0025.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Roman Catholic community held its first mass in a local home, and it was not until the 1920s that the Catholics had their own mission church in Winter Park. It was a lovely little building, just around the corner from the present sanctuary, facing onto Canton.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "61%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0026.jpg",
      "src": "images/e9781439629895_i0026.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In 1885, the Winter Park Company donated the land for the Episcopal church at Interlachen Avenue and Lyman. The church was organized as All Saints Episcopal Church and held its first service on Christmas Day 1886, with the Rev. Canon George C. Street presiding. The Winter Park Company felt the community needed to have churches for its winter visitors and promoted the fact in its 19th-century guidebook: “There are three church organizations in Winter Park, and ample facilities are provided for the accommodation of church-goers within 3 minutes’ walk of the Seminole.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781439629895_bm01#end_en9",
      "id": "ref_end_en9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("7")])])]), _vm._v(" Bishop Henry Whipple of Minnesota had a winter home in Winter Park, and he helped out with pastoral duties at All Saints. Winter Park pioneer Mary Brown (the keen observer of latecomers to Easter service) was the daughter of an Episcopal missionary and a founding member of All Saints.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0027.jpg",
      "src": "images/e9781439629895_i0027.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("At the center of the city, Winter Park’s designers created Central Park to add charm to their resort. One early visitor wasn’t impressed and wrote, “I remember landing in Winter Park on a dingy little wooden structure which was the depot and facing a park that was unkempt.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781439629895_bm01#end_en10",
      "id": "ref_end_en10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("8")])])]), _vm._v(" He must have caught Central Park on a bad day.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0028.jpg",
      "src": "images/e9781439629895_i0028.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The original plan was to plant the park with tropical fruits and flowers to look as it appears on the previous card. But shade trees were also planted, and as they grew, the look changed. This card’s sender noted with glee in January 1924, “Today seems like a beautiful day in June, warm but not hot and everything beautiful under the glorious sunlight.”")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0029.jpg",
      "src": "images/e9781439629895_i0029.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("At one time, there was even a tennis court in Central Park. Generally, the status of the park depended a great deal on the economy. In 1936, when the Great Depression caused cutbacks, resident R. B. Barbour stepped in with a beautification plan. The Winter Park Garden Club helped out too, adding a rose garden, a stone seat, a sundial, and a birdbath.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0030.jpg",
      "src": "images/e9781439629895_i0030.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("There were alligators and turtles in a pen in the park for a while, probably placed there because these exotic creatures were always interesting to visitors. They were removed in 1918. The person who sent this card sounded a forlorn note in January of that year when he wrote, “This is what we might have seen if there hadn’t been a Florida freeze!”")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0031.jpg",
      "src": "images/e9781439629895_i0031.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("“Winter Park did not ‘just grow,’ ” wrote Orange County historian William F. Blackman in 1927. “It was predetermined and guided.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781439629895_bm01#end_en11",
      "id": "ref_end_en11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("9")])])]), _vm._v(" The city’s founders laid out wide avenues and set aside land for hotels and schools, as well as for Central Park. In this vintage card, Interlachen Avenue doesn’t look like much, but you can see the founders’ foresight in the pretty line of trees they planted along the roadside.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0032.jpg",
      "src": "images/e9781439629895_i0032.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Winter Park’s third main thoroughfare—after Park Avenue and Interlachen—was at first just called the Boulevard. Now called Morse Boulevard, it was planted with a double row of trees down the center, designed to shade the sidewalk. Electric street lighting was installed in 1904, and the light shown on this vintage card is one of the early ones. The lights were designed to be taken down and stored during the summer.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0033.jpg",
      "src": "images/e9781439629895_i0033.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("As is usual in the Florida climate, residents had to work hard to keep the lakesides from being taken over by the subtropical jungle. This card, which carries a 1910 Winter Park postmark, reads as follows: “I am sending you a picture of our canal after the brush has been cleared out. I think the lake (Osceola) looks pretty now. What do you think of our oaks, moss and orange groves in the distance?”")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0034.jpg",
      "src": "images/e9781439629895_i0034.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This visitor wrote, “This card shows you where I am but does not tell you how warm it is. 70° here this morning. All in summer dress, windows and doors all open, petunias and geraniums in bloom.” It was February, and the sender couldn’t resist adding, “I hope the weather has improved in Glens Falls.”")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "42%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0035.jpg",
      "src": "images/e9781439629895_i0035.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("As Winter Park chugged along into the 20th century, it carried with it some important advantages that would one day secure it a place as a first-rate city. Its economy was fragile, and that would be exposed in the coming years as economic difficulties threatened the tiny resort. First, Winter Park got some unexpected good news—news that would forever mark it as an important city on the Florida map.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439629895_i0036.jpg",
      "src": "images/e9781439629895_i0036.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-710e762c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439629895_c01.vue
// module id = 78
// module chunks = 0